/**
 * Constants class that defines the current version of the library.
 */
export class Version {

    /**
     * @type {string} - The current version of this library
     */
    public static CLOVER_CLOUD_SDK_VERSION = "4.1.2";

    /**
     * @type {string} - The current SDK name.
     */
    public static CLOVER_CLOUD_SDK: string = "com.clover.cloverconnector.cloud";
}
